import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div>
            <header className='header-part'>
                <img src="https://www.parkersoftware.com/wp-content/uploads/2020/10/pankaj-patel-_SgRNwAVNKw-unsplash-scaled.jpg" alt="" />
                <p>Everyone's talking about coding, but where do you start? This path will give you an introduction to the world of code and basic concepts. By the end, you'll know whether Data Science, Computer Science or Web Development is right for you.</p>
            </header>
        </div>
    );
};

export default Header;